import { BasePropertyApi } from './base-api.interface';
import { getBorderStyleData } from './get-common-properties';
import { updateBorderStyleData } from './update-common-properties';

export const borderStyleAPI: BasePropertyApi = {
  get: getBorderStyleData,
  update: updateBorderStyleData,
};
